import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const aspectRatio = 9 / 16;
const WrapperDiv = styled.div.withConfig({
  displayName: "IFrame__WrapperDiv",
  componentId: "ndqz0h-0"
})(["position:relative;padding-bottom:", "%;height:0;"], aspectRatio * 100);
const StyledIFrame = styled.iframe.withConfig({
  displayName: "IFrame__StyledIFrame",
  componentId: "ndqz0h-1"
})(["position:absolute;top:0;left:0;width:100%;height:100%;border:none;"]);
export const IFrame = props => {
  return /*#__PURE__*/_jsx(WrapperDiv, {
    children: /*#__PURE__*/_jsx(StyledIFrame, Object.assign({}, props, {
      loading: "lazy"
    }))
  });
};
export default IFrame;